// EmailBodyPreview — переключатель превью тела письма (V17 W5a):
// песочный native iframe vs редактируемый HTML; тема — controlled TextField.

import { useState } from 'react';
import { Box, Stack, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { t } from '@/i18n';

/** Высота песочного iframe превью (px), канон ТЗ W5a. */
const PREVIEW_IFRAME_HEIGHT_PX = 240;

/**
 * Переключатель превью тела письма: песочный iframe или редактируемый HTML.
 *
 * @param props.subject — тема письма (controlled).
 * @param props.body — HTML-тело (controlled).
 * @param props.onSubjectChange — смена темы родителем.
 * @param props.onBodyChange — смена HTML-тела родителем.
 */
export function EmailBodyPreview(props: {
  subject: string;
  body: string;
  onSubjectChange: (value: string) => void;
  onBodyChange: (value: string) => void;
}): JSX.Element {
  const [mode, setMode] = useState<'rendered' | 'html'>('rendered');
  return (
    <Stack spacing={1}>
      <TextField
        label={t('email.send.subject')}
        value={props.subject}
        onChange={(e) => props.onSubjectChange(e.target.value)}
        inputProps={{ 'aria-label': t('email.send.subject') }}
      />
      <ToggleButtonGroup
        exclusive
        size="small"
        value={mode}
        onChange={(_e, next: 'rendered' | 'html' | null) => {
          if (next) setMode(next);
        }}
      >
        <ToggleButton value="rendered" aria-label={t('email.send.previewRendered')}>
          {t('email.send.previewRendered')}
        </ToggleButton>
        <ToggleButton value="html" aria-label={t('email.send.previewHtml')}>
          {t('email.send.previewHtml')}
        </ToggleButton>
      </ToggleButtonGroup>
      {mode === 'rendered' ? (
        <Box sx={{ width: '100%', minHeight: PREVIEW_IFRAME_HEIGHT_PX, border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
          <iframe
            sandbox=""
            srcDoc={props.body}
            title={t('email.send.previewRendered')}
            style={{ width: '100%', height: PREVIEW_IFRAME_HEIGHT_PX, border: 0 }}
          />
        </Box>
      ) : (
        <TextField
          multiline
          minRows={10}
          value={props.body}
          onChange={(e) => props.onBodyChange(e.target.value)}
          inputProps={{ 'aria-label': t('email.send.previewHtml') }}
        />
      )}
    </Stack>
  );
}
